<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <transition>
      <router-view/>
    </transition>

  </div>
</template>

<script>
import share from '@/api/wxShare'
export default {
  name: 'App',
  created: function () {
    let ug = navigator.userAgent.toLowerCase()
    let mob = ug.match(/Mobile/i) && ug.match(/Mobile/i)[0] === 'mobile'
    let micro = ug.match(/MicroMessenger/i) && ug.match(/MicroMessenger/i)[0] === 'micromessenger'
    if (mob && micro) {
      // console.log(this.getCookie('openid'))
      if (this.getCookie('openid')) {
        // localStorage.setItem('openid', openid)
        // 先设置cookie的时间为会话时间
        // document.cookie = 'openid=' + this.getCookie('openid') + ';domain=letzgo.com.cn;expires=-1;path=/'
        // 这里调取分享接口
        share()
      } else {
        let environment = location.host
        if (environment.indexOf('dev') > -1) {
          environment = 'TEST'
        } else if (environment.indexOf('qa01') > -1) {
          environment = 'QA01'
        } else if (environment.indexOf('qa02') > -1) {
          environment = 'QA02'
        } else if (environment.indexOf('uat01') > -1) {
          environment = 'UAT01'
        } else {
          environment = 'WXAUTH'
        }
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfcd4b30ac2e525c2&redirect_uri=https://tg-sh.letzgo.com.cn/dzcx_tg/authorize/wechat/v2&response_type=code&scope=snsapi_base&state=' + environment + '#wechat_redirect'
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx529a1f5eab78966f&redirect_uri=https://uat01.letzgo.com.cn/dzcx_tg/authorize/wechat/v2&response_type=code&scope=snsapi_base&state=TEST#wechat_redirect'
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5f76d54c37729725&redirect_uri=https://uat01.letzgo.com.cn/dzcx_tg/authorize/wechat/v2&response_type=code&scope=snsapi_base&state=TEST#wechat_redirect'
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5f76d54c37729725&redirect_uri=https://uat01.letzgo.com.cn/dzcx_tg/authorize/wechat/v2&response_type=code&scope=snsapi_base&state=TEST#wechat_redirect'
      }
    }
  },
  methods: {
    getCookie (name) {
      let strcookie = document.cookie // 获取cookie字符串
      let arrcookie = strcookie.split('; ') // 分割
      // 遍历匹配
      for (let i = 0; i < arrcookie.length; i++) {
        let arr = arrcookie[i].split('=')
        if (arr[0] === name) {
          return arr[1]
        }
      }
      return ''
    }
  }
}
</script>

<style lang="postcss">
@import './style/dzcx-mint.css';
#app{
  position: relative;
  min-height: 100vh;
  box-sizing: border-box;
  color: #343434;
}
.icon {
  width: 1em; height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.login-btn{
  width: 100%;
  height: 96px;
  background: linear-gradient(-180deg, #01CDF4 4%, #00BCF7 100%);
  border-radius: 100px;
  font-size: 32px;
  color: #fff;
}
.cancel{
  font-size: 32px;
  color: #9E9E9E;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue